import React, { useState, useRef, useEffect } from 'react';
import './Cibil.css';
import ReCAPTCHA from "react-google-recaptcha";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Cibil = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    dob: '',
    mobile: '',
    email: '',
    pan: '',
    agreeTerms: false
  });

  const [errors, setErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      easing: 'ease-in-out'
    });
  }, []);

  const faqData = [
    {
      q: "How can I get my full CIBIL report free?",
      a: "You can get your full CIBIL report free once a year from CIBIL's official website or through RBI-approved credit bureaus."
    },
    {
      q: "What is the best way to check CIBIL score?",
      a: "The best way is to check directly through CIBIL's official website or secure platforms like Krishna Finconcept Services."
    },
    {
      q: "Are there any charges to check CIBIL score?",
      a: "Checking your basic score is often free; however, detailed monthly monitoring may require a subscription."
    }
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
    if (errors.captcha) setErrors(prev => ({ ...prev, captcha: null }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.agreeTerms) {
      alert('Please agree to the terms and conditions');
      return;
    }

    if (!captchaToken) {
      setErrors({ captcha: "Please complete the reCAPTCHA" });
      return;
    }

    console.log('Form submitted:', formData);
    alert('Thank you! Your credit report request has been submitted.');
  };

  const handleFaqClick = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  return (
    <div className="cibil-page">
      {/* Enhanced Animated Background */}
      <div className="cibil-animated-bg">
        <div className="cibil-gradient-orb cibil-orb-1"></div>
        <div className="cibil-gradient-orb cibil-orb-2"></div>
        <div className="cibil-gradient-orb cibil-orb-3"></div>
        <div className="cibil-gradient-orb cibil-orb-4"></div>
      </div>

      {/* Floating Particles */}
      <div className="cibil-floating-particles">
        {[...Array(15)].map((_, i) => (
          <div key={i} className={`cibil-particle cibil-particle-${i}`}></div>
        ))}
      </div>

      {/* Decorative background blobs */}
      <div className="cibil-bg-blob cibil-blob-1"></div>
      <div className="cibil-bg-blob cibil-blob-2"></div>

      {/* Hero Section */}
      <section className="cibil-hero-section">
        <div className="cibil-container-wrapper">
          {/* Left Content */}
          <div className="cibil-hero-content" data-aos="fade-right" data-aos-duration="1200">
            <div className="cibil-badge-wrapper">
              <div className="cibil-badge-shine"></div>
              <div className="cibil-badge">✨ Trusted by 1M+ Users</div>
            </div>
            
            <h1 className="cibil-gradient-heading" data-aos="fade-up" data-aos-delay="200">
              Unlock Your Financial <br />
              <span className="cibil-blue-gradient-text">Freedom Today.</span>
            </h1>
            
            <div className="cibil-hero-image-wrapper" data-aos="zoom-in" data-aos-delay="400">
              <div className="cibil-image-glow"></div>
              <img src="/images/credit-score.png" alt="CIBIL Score" className="cibil-floating-img" />
              <div className="cibil-floating-badge cibil-badge-1" data-aos="fade-left" data-aos-delay="600">
                <span className="cibil-badge-icon">📊</span>
                750+ Score
              </div>
              <div className="cibil-floating-badge cibil-badge-2" data-aos="fade-right" data-aos-delay="800">
                <span className="cibil-badge-icon">⚡</span>
                Instant Check
              </div>
            </div>

            <div className="cibil-trust-indicators" data-aos="fade-up" data-aos-delay="500">
              <div className="cibil-trust-item">
                <span className="cibil-trust-icon">🔒</span>
                <div className="cibil-trust-text">
                  <strong>100% Secure</strong>
                  <small>256-bit SSL</small>
                </div>
              </div>
              <div className="cibil-trust-item">
                <span className="cibil-trust-icon">⚡</span>
                <div className="cibil-trust-text">
                  <strong>Instant Access</strong>
                  <small>No waiting</small>
                </div>
              </div>
              <div className="cibil-trust-item">
                <span className="cibil-trust-icon">🆓</span>
                <div className="cibil-trust-text">
                  <strong>Free Check</strong>
                  <small>No hidden fees</small>
                </div>
              </div>
            </div>
          </div>

          {/* Right Form Card */}
          <div className="cibil-form-card-glass" data-aos="fade-left" data-aos-duration="1200" data-aos-delay="200">
            <div className="cibil-form-header">
              <div className="cibil-form-icon">📋</div>
              <h3>Get Your Free Report</h3>
              <p>Fill in your details as per your PAN card</p>
              <div className="cibil-progress-indicator">
                <div className="cibil-progress-step cibil-active"></div>
                <div className="cibil-progress-step"></div>
                <div className="cibil-progress-step"></div>
              </div>
            </div>

            <form className="cibil-modern-form" onSubmit={handleSubmit}>
              <div className="cibil-input-row">
                <div className="cibil-input-group cibil-floating-label" data-aos="fade-up" data-aos-delay="300">
                  <input 
                    type="text" 
                    name="fullName" 
                    required 
                    placeholder=" " 
                    onChange={handleChange}
                    className="cibil-animated-input"
                  />
                  <label>Full Name (As per PAN)</label>
                  <span className="cibil-input-focus-border"></span>
                </div>
                
                <div className="cibil-input-group cibil-floating-label" data-aos="fade-up" data-aos-delay="400">
                  <input 
                    type="text" 
                    name="dob" 
                    required 
                    placeholder=" " 
                    onChange={handleChange}
                    className="cibil-animated-input"
                  />
                  <label>DOB (DD-MM-YYYY)</label>
                  <span className="cibil-input-focus-border"></span>
                </div>
              </div>

              <div className="cibil-input-row">
                <div className="cibil-input-group cibil-floating-label cibil-prefix-group" data-aos="fade-up" data-aos-delay="500">
                  <span className="cibil-country-code"></span>
                  <input 
                    type="tel" 
                    name="mobile" 
                    required 
                    placeholder=" " 
                    onChange={handleChange}
                    className="cibil-animated-input"
                  />
                  <label>Mobile Number</label>
                  <span className="cibil-input-focus-border"></span>
                </div>
                
                <div className="cibil-input-group cibil-floating-label" data-aos="fade-up" data-aos-delay="600">
                  <input 
                    type="email" 
                    name="email" 
                    required 
                    placeholder=" " 
                    onChange={handleChange}
                    className="cibil-animated-input"
                  />
                  <label>Email Address</label>
                  <span className="cibil-input-focus-border"></span>
                </div>
              </div>

              <div className="cibil-input-group cibil-floating-label cibil-full-width" data-aos="fade-up" data-aos-delay="700">
                <input 
                  type="text" 
                  name="pan" 
                  className="cibil-uppercase cibil-animated-input" 
                  required 
                  placeholder=" " 
                  onChange={handleChange}
                  maxLength="10"
                />
                <label>PAN Card Number</label>
                <span className="cibil-input-focus-border"></span>
                <div className="cibil-input-hint">Format: ABCDE1234F</div>
              </div>

              <div className="cibil-consent-container" data-aos="fade-up" data-aos-delay="800">
                <label className="cibil-checkbox-wrapper">
                  <input type="checkbox" name="agreeTerms" required onChange={handleChange} />
                  <span className="cibil-checkmark"></span>
                  <span className="cibil-consent-text">
                    I agree to the <a href="#">Terms & Conditions</a> and authorize sharing info with Krishna Finconcept.
                  </span>
                </label>
              </div>

              <div className="cibil-kr-captcha-container" data-aos="fade-up" data-aos-delay="900">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey="6Ldk_IksAAAAAO8Aq02xgOPeBlszLT2K30hdJCjM"
                  onChange={handleCaptchaChange}
                />
              </div>

              {errors.captcha && (
                <span className="cibil-error-message cibil-shake-animation">
                  {errors.captcha}
                </span>
              )}

              <button type="submit" className="cibil-shiny-btn" data-aos="zoom-in" data-aos-delay="1000">
                <span className="cibil-btn-text">Check My Score Now</span>
                <div className="cibil-btn-light"></div>
                <div className="cibil-btn-shine"></div>
                <div className="cibil-btn-particles"></div>
              </button>

              <div className="cibil-form-footer" data-aos="fade-up" data-aos-delay="1100">
                <p>By continuing, you agree to our <a href="#">Privacy Policy</a></p>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Content Sections */}
      <div className="cibil-content-container">

        {/* Quick Stats Section */}
        <div className="cibil-stats-grid">
          <div className="cibil-stat-card" data-aos="flip-left" data-aos-delay="100">
            <div className="cibil-stat-icon">🏆</div>
            <div className="cibil-stat-number">1M+</div>
            <div className="cibil-stat-label">Happy Customers</div>
          </div>
          <div className="cibil-stat-card" data-aos="flip-left" data-aos-delay="200">
            <div className="cibil-stat-icon">💳</div>
            <div className="cibil-stat-number">50+</div>
            <div className="cibil-stat-label">Bank Partners</div>
          </div>
          <div className="cibil-stat-card" data-aos="flip-left" data-aos-delay="300">
            <div className="cibil-stat-icon">⚡</div>
            <div className="cibil-stat-number">24/7</div>
            <div className="cibil-stat-label">Support</div>
          </div>
          <div className="cibil-stat-card" data-aos="flip-left" data-aos-delay="400">
            <div className="cibil-stat-icon">🔒</div>
            <div className="cibil-stat-number">100%</div>
            <div className="cibil-stat-label">Secure</div>
          </div>
        </div>

        {/* What is CIBIL Score */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">📈</span>
            <h2>What is CIBIL Score and How Does It Work?</h2>
          </div>
          <div className="cibil-content-card">
            <p>
              A CIBIL Score is a three-digit number ranging between <strong className="cibil-highlight">300 and 900</strong> that indicates your creditworthiness.
              Scores closer to 900 represent better creditworthiness. Banks typically consider a score of <strong className="cibil-highlight">700 or higher</strong>
              as a benchmark for favorable rates.
            </p>
            <div className="cibil-score-visual">
              <div className="cibil-score-bar">
                <div className="cibil-score-fill" style={{ width: '75%' }}></div>
              </div>
              <div className="cibil-score-labels">
                <span>300</span>
                <span>Poor</span>
                <span>Fair</span>
                <span>Good</span>
                <span>Excellent</span>
                <span>900</span>
              </div>
            </div>
          </div>
        </section>

        {/* How to Check */}
        <section className="cibil-info-block cibil-gray-bg" data-aos="fade-up" data-aos-delay="100">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">📝</span>
            <h2>How to Check Your CIBIL Score Online</h2>
          </div>
          <div className="cibil-steps-timeline">
            {[
              "Visit Krishna Finconcept Services",
              "Click on “Credit Score”",
              "Enter personal details",
              "Tap on “Check CIBIL Score”",
              "Receive OTP",
              "Input OTP and submit",
              "View your score"
            ].map((step, index) => (
              <div key={index} className="cibil-timeline-step" data-aos="fade-left" data-aos-delay={index * 50}>
                <div className="cibil-step-number">{index + 1}</div>
                <div className="cibil-step-content">{step}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Importance Cards */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">⭐</span>
            <h2>Importance of CIBIL Score</h2>
          </div>
          <div className="cibil-cards-grid">
            {[
              { icon: '✅', title: 'Loan Approval', desc: 'Increases chances of approval' },
              { icon: '💰', title: 'Lower Interest Rates', desc: 'Save money with better rates' },
              { icon: '⚡', title: 'Quick Processing', desc: 'Faster approvals with minimal docs' }
            ].map((item, index) => (
              <div key={index} className="cibil-info-card" data-aos="flip-up" data-aos-delay={index * 100}>
                <div className="cibil-card-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Score Ranges */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">📊</span>
            <h2>CIBIL Score Ranges</h2>
          </div>
          <div className="cibil-score-ranges-container">
            {[
              { range: '750 – 900', label: 'Excellent', color: '#28a745', desc: 'Best interest rates' },
              { range: '700 – 749', label: 'Good', color: '#8bc34a', desc: 'Favorable terms' },
              { range: '650 – 699', label: 'Fair', color: '#ffc107', desc: 'Moderate rates' },
              { range: '600 – 649', label: 'Subnormal', color: '#ff9800', desc: 'High interest' },
              { range: 'Below 600', label: 'Poor', color: '#dc3545', desc: 'Difficult approval' }
            ].map((item, index) => (
              <div key={index} className="cibil-range-item" data-aos="fade-right" data-aos-delay={index * 50}>
                <div className="cibil-range-color" style={{ backgroundColor: item.color }}></div>
                <div className="cibil-range-details">
                  <span className="cibil-range-value">{item.range}</span>
                  <span className="cibil-range-label">{item.label}</span>
                  <span className="cibil-range-desc">{item.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Comparison Table */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">🔄</span>
            <h2>Difference Between CIBIL Score and Credit Score</h2>
          </div>
          <p data-aos="fade-up" data-aos-delay="100">Here are the key differences between CIBIL Score and Credit Score:</p>
          <div className="cibil-table-responsive" data-aos="zoom-in" data-aos-delay="200">
            <table className="cibil-comparison-table cibil-enhanced-table">
              <thead>
                <tr>
                  <th>Aspect</th>
                  <th>CIBIL Score</th>
                  <th>Credit Score</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Definition</strong></td>
                  <td>Numerical representation by TransUnion CIBIL</td>
                  <td>Representation by any credit bureau</td>
                </tr>
                <tr>
                  <td><strong>Usage</strong></td>
                  <td>Used for credit applications assessment</td>
                  <td>Used for creditworthiness assessment</td>
                </tr>
                <tr>
                  <td><strong>Range</strong></td>
                  <td>300 to 900</td>
                  <td>Typically 300 to 900</td>
                </tr>
                <tr>
                  <td><strong>Access</strong></td>
                  <td>Free via Krishna Finconcept Services</td>
                  <td>Check via any credit bureau</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Benefits List */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">💡</span>
            <h2>Benefits of Good CIBIL Score</h2>
          </div>
          <p>Let's examine the applicable benefits of having a better CIBIL score:</p>
          <div className="cibil-benefits-cloud">
            {[
              'Easy Loan Approval',
              'Lower Interest Rates',
              'Higher Credit Limits',
              'Better Loan Offers',
              'Quick Loan Processing',
              'Negotiating Power'
            ].map((benefit, index) => (
              <div key={index} className="cibil-benefit-pill" data-aos="zoom-in" data-aos-delay={index * 50}>
                <span className="cibil-benefit-check">✓</span>
                {benefit}
              </div>
            ))}
          </div>
        </section>

        {/* Factors Section */}
        <section className="cibil-info-block cibil-gray-bg" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">⚖️</span>
            <h2>Factors That Affect Your CIBIL Score</h2>
          </div>
          
          <div className="cibil-sub-section" data-aos="fade-right">
            <h3 className="cibil-sub-title">Factors That Affect Your CIBIL Score</h3>
            <ul className="cibil-custom-list cibil-animated-list">
              <li><strong>Payment History:</strong> Default on your loan EMIs and bills can significantly negatively affect your CIBIL Score.</li>
              <li><strong>Credit Utilisation Ratio:</strong> A high percentage of credit usage can lower your CIBIL score; maintain it below 30%.</li>
              <li><strong>Credit Mix and Duration:</strong> A diverse credit portfolio and a longer credit history can improve your CIBIL score.</li>
              <li><strong>Outstanding Debt:</strong> High amounts of existing debt can decrease your CIBIL Score.</li>
              <li><strong>Number of Enquiries:</strong> Too many hard credit inquiries can lower your score.</li>
            </ul>
          </div>

          <div className="cibil-sub-section" data-aos="fade-left" data-aos-delay="200">
            <h3 className="cibil-sub-title">Factors That Don't Affect Your CIBIL Score</h3>
            <ul className="cibil-custom-list cibil-animated-list">
              <li><strong>Income Level:</strong> Your income does not impact your CIBIL score.</li>
              <li><strong>CIBIL Score Check Online:</strong> Checking your own score doesn't affect your credit.</li>
              <li><strong>Debit Card Usage:</strong> Debit card transactions don't impact score.</li>
              <li><strong>Marital Status:</strong> Getting married does not affect your credit score.</li>
              <li><strong>Denied Credit Applications:</strong> Rejection isn't reflected in your report.</li>
            </ul>
          </div>
        </section>

        {/* Tips Section */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">🎯</span>
            <h2>Tips to Improve Your CIBIL Score</h2>
          </div>
          <div className="cibil-tips-grid">
            {[
              { title: 'Pay on Time', desc: 'Pay EMIs and credit card bills on time' },
              { title: 'Maintain Old Cards', desc: 'Keep old credit cards active' },
              { title: 'Limit Usage', desc: 'Keep credit utilisation below 30%' },
              { title: 'Healthy Mix', desc: 'Balance secured and unsecured loans' },
              { title: 'Regular Checks', desc: 'Review your credit report regularly' },
              { title: 'Avoid Multiple Apps', desc: 'Apply only for needed credit' }
            ].map((tip, index) => (
              <div key={index} className="cibil-tip-card" data-aos="flip-up" data-aos-delay={index * 50}>
                <div className="cibil-tip-number">{index + 1}</div>
                <h4>{tip.title}</h4>
                <p>{tip.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Calculation Section */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">🧮</span>
            <h2>How Is CIBIL Score Calculated?</h2>
          </div>
          
          <div className="cibil-calculation-grid">
            {[
              { title: 'Payment History', percent: '35%', desc: 'Track record of paying bills and EMIs' },
              { title: 'Credit Utilisation', percent: '30%', desc: 'Credit used vs available limit' },
              { title: 'Credit Mix & Duration', percent: '25%', desc: 'Types of credit and history length' },
              { title: 'Other Factors', percent: '10%', desc: 'Inquiries, outstanding amount, etc.' }
            ].map((item, index) => (
              <div key={index} className="cibil-calculation-card" data-aos="fade-up" data-aos-delay={index * 100}>
                <h3>{item.title}</h3>
                <div className="cibil-percent-circle">
                  <svg viewBox="0 0 36 36">
                    <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#e0e0e0" strokeWidth="3"/>
                    <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#0052cc" strokeWidth="3" strokeDasharray={`${parseInt(item.percent)}, 100`}/>
                  </svg>
                  <span className="cibil-percent-text">{item.percent}</span>
                </div>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CIBIL Report Section */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">📄</span>
            <h2>What Is a CIBIL Report?</h2>
          </div>
          <div className="cibil-content-card">
            <p>
              A CIBIL Report is a specialized document officially known as a <strong>Credit Information Report (CIR)</strong>.
              Prepared by TransUnion CIBIL—India's leading credit bureau—it provides a comprehensive and detailed
              overview of your creditworthiness.
            </p>
            <div className="cibil-report-highlights">
              <div className="cibil-highlight-item">
                <span className="cibil-highlight-icon">📊</span>
                <span>Personal Information</span>
              </div>
              <div className="cibil-highlight-item">
                <span className="cibil-highlight-icon">💳</span>
                <span>Credit Accounts</span>
              </div>
              <div className="cibil-highlight-item">
                <span className="cibil-highlight-icon">📈</span>
                <span>Payment History</span>
              </div>
              <div className="cibil-highlight-item">
                <span className="cibil-highlight-icon">🔍</span>
                <span>Credit Inquiries</span>
              </div>
            </div>
          </div>
        </section>

        {/* Credit Inquiries */}
        <section className="cibil-info-block cibil-gray-bg" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">🔎</span>
            <h2>Impact of Credit Inquiries on CIBIL Score</h2>
          </div>
          <div className="cibil-inquiry-comparison">
            <div className="cibil-inquiry-card cibil-hard" data-aos="fade-right">
              <div className="cibil-inquiry-icon">🔴</div>
              <h3>Hard Inquiry</h3>
              <p>Occurs when you apply for credit</p>
              <div className="cibil-impact-badge cibil-negative">Slightly lowers score</div>
            </div>
            <div className="cibil-inquiry-card cibil-soft" data-aos="fade-left">
              <div className="cibil-inquiry-icon">🟢</div>
              <h3>Soft Inquiry</h3>
              <p>Checking your own score</p>
              <div className="cibil-impact-badge cibil-positive">No impact on score</div>
            </div>
          </div>
        </section>

        {/* Good Score Section */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">🎯</span>
            <h2>What Is a Good CIBIL Score?</h2>
          </div>
          <div className="cibil-score-breakdown">
            <div className="cibil-score-meter-large">
              <div className="cibil-meter-gradient"></div>
              <div className="cibil-score-indicator" style={{ left: '75%' }}>700+</div>
            </div>
            <p>
              In the Indian lending landscape, a CIBIL score of <strong>700 or above</strong> is generally
              considered ideal by most banks and NBFCs.
            </p>
          </div>
        </section>

        {/* Credit Bureaus */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">🏦</span>
            <h2>Credit Bureaus in India</h2>
          </div>
          <div className="cibil-bureau-grid">
            {[
              { name: 'TransUnion CIBIL', desc: "India's Prime Credit Bureau" },
              { name: 'Experian', desc: 'Global information services company' },
              { name: 'Equifax', desc: 'International credit bureau' },
              { name: 'CRIF High Mark', desc: 'Specialized credit information' }
            ].map((bureau, index) => (
              <div key={index} className="cibil-bureau-card" data-aos="flip-up" data-aos-delay={index * 100}>
                <h4>{bureau.name}</h4>
                <p>{bureau.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CIR Section */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">📋</span>
            <h2>What is a CIR and How is It Related to CIBIL Score?</h2>
          </div>
          <div className="cibil-cir-explanation">
            <p>
              <strong>CIR</strong> stands for Credit Information Report. It is a comprehensive statement that demonstrates your
              entire credit history. Your <strong>CIBIL Score</strong> is a three-digit numerical representation derived from this CIR.
            </p>
            <div className="cibil-cir-diagram">
              <div className="cibil-diagram-item">CIR (Credit History)</div>
              <div className="cibil-diagram-arrow">→</div>
              <div className="cibil-diagram-item">CIBIL Score</div>
            </div>
          </div>
        </section>

        {/* Credit Card Applications */}
        <section className="cibil-info-block cibil-gray-bg" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">💳</span>
            <h2>How is CIBIL Score Used in Credit Card Applications?</h2>
          </div>
          <div className="cibil-feature-grid">
            {[
              'Eligibility Check',
              'Credit Limit',
              'Interest Rates',
              'Approval Process',
              'Loan Offers'
            ].map((feature, index) => (
              <div key={index} className="cibil-feature-item" data-aos="zoom-in" data-aos-delay={index * 50}>
                <span className="cibil-feature-icon">✓</span>
                {feature}
              </div>
            ))}
          </div>
        </section>

        {/* Personal Loans */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">💰</span>
            <h2>Role of CIBIL Score in Personal Loan Applications</h2>
          </div>
          <ul className="cibil-custom-list cibil-animated-list">
            <li><strong>Assessment of Creditworthiness:</strong> Gauges your history and repayment behaviour.</li>
            <li><strong>Loan Approval:</strong> Increases the likelihood of approval.</li>
            <li><strong>Interest Rates:</strong> Helps in securing lower interest rates.</li>
            <li><strong>Loan Terms:</strong> Leads to higher loan amounts.</li>
            <li><strong>Processing Time:</strong> Expedites verification process.</li>
          </ul>
        </section>

        {/* Home Loans */}
        <section className="cibil-info-block cibil-gray-bg" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">🏠</span>
            <h2>How Does a CIBIL Score Influence Home Loan</h2>
          </div>
          <ul className="cibil-custom-list cibil-animated-list">
            <li><strong>Loan Approval:</strong> High scores empower faster approval.</li>
            <li><strong>Interest Rates:</strong> Qualifies you for lower rates.</li>
            <li><strong>Loan Terms:</strong> Provides access to higher amounts.</li>
            <li><strong>Negotiation Power:</strong> Allows you to negotiate better terms.</li>
            <li><strong>Quick Processing:</strong> Facilitates minimal documentation.</li>
          </ul>
        </section>

        {/* Misconceptions */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">❌</span>
            <h2>Common Misconceptions About CIBIL Scores</h2>
          </div>
          <div className="cibil-myth-busters">
            {[
              'High income equals high score',
              'Only repayment matters',
              'Debit cards affect score',
              'Self-checking lowers score',
              'Closing loans erases history'
            ].map((myth, index) => (
              <div key={index} className="cibil-myth-item" data-aos="fade-right" data-aos-delay={index * 50}>
                <span className="cibil-myth-icon">❌</span>
                <span className="cibil-myth-text">{myth}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Checklist */}
        <section className="cibil-info-block cibil-gray-bg" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">✅</span>
            <h2>CIBIL Credit Report Checklist</h2>
          </div>
          <div className="cibil-checklist-container">
            {[
              'Verify Personal Information',
              'Check Contact Details',
              'Review Account Information',
              'Analyse Credit Utilisation',
              'Scrutinise Enquiry Information',
              'Identify Frauds'
            ].map((item, index) => (
              <div key={index} className="cibil-checklist-item" data-aos="fade-left" data-aos-delay={index * 50}>
                <span className="cibil-checklist-checkbox"></span>
                <span className="cibil-checklist-text">{item}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Consent Withdrawal */}
        <section className="cibil-info-block" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">📝</span>
            <h2>Consent Withdrawal Process</h2>
          </div>
          <div className="cibil-consent-content">
            <p>
              Our consent withdrawal policy states that you can revoke the usage of the information you have provided to Krishna Finconcept Services during the CIBIL score check process. This means that every information we have pertaining to you shall be discarded from our database without any discretion.
            </p>
            <div className="cibil-consent-note">
              <strong>Note:</strong> We are required to retain certain information for legal compliance.
            </div>
          </div>
        </section>

        {/* FAQ Accordion Section */}
        <div className="cibil-faq-accordion-container" data-aos="fade-up">
          <div className="cibil-section-header">
            <span className="cibil-section-icon">❓</span>
            <h2 className="cibil-faq-accordion-main-title">Frequently Asked Questions</h2>
          </div>
          <div className="cibil-faq-accordion">
            {faqData.map((faq, index) => (
              <div 
                key={index} 
                className={`cibil-faq-accordion-item ${openFaqIndex === index ? 'cibil-active' : ''}`}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <button className="cibil-faq-accordion-question" onClick={() => handleFaqClick(index)}>
                  <span>{faq.q}</span>
                  <span className="cibil-faq-accordion-icon">{openFaqIndex === index ? '−' : '+'}</span>
                </button>
                <div className="cibil-faq-accordion-answer">
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <section className="cibil-cta-enhanced" data-aos="zoom-in">
          <h2>Ready to Check Your CIBIL Score?</h2>
          <p>Join millions of Indians who trust us for their credit health</p>
          <button className="cibil-cta-button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <span>Get Your Score Now</span>
            <span className="cibil-cta-arrow">→</span>
          </button>
        </section>
      </div>
    </div>
  );
};

export default Cibil;